export class HabilitationStatutWorkflow {
    static jsonMap = {
        id: { key: 'id' },
        idStatut: { key: 'idRefStatutOld' },
        idNextStatut: { key: 'idRefStatutNew' }
    };

    public id: number = undefined;
    public idStatut: number = undefined;
    public idNextStatut: number = undefined;
}
